<template>
  <div class="mx-auto">
    <v-card flat class="pa-2">
      <v-container class="pa-5">
        <v-list-item class="px-0">
          <v-list-item-content>
            <v-row no-gutters>
              <v-col cols="12" md="4">
                <v-list-item class="px-0">
                  <v-list-item-avatar color="blue">
                    <v-icon dark>mdi-account</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0">
                    <v-label color="caption"><small>Nama Koordinator</small></v-label>
                    <v-list-item-subtitle class="link black--text body-2">
                      <div class="blue--text">
                        {{ $getDeepObj(koordinator, 'nama') || '-' }}
                      </div>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="4">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0">
                    <v-label color="caption"><small>Kontak</small></v-label>
                    <v-list-item-subtitle class="link black--text body-2">
                      <span> {{ $getDeepObj(koordinator, 'no_hp') || '-' }} </span><br />
                      <span>
                        {{ $getDeepObj(koordinator, 'email') || '-' }}
                      </span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
        <v-spacer />
        <div>
          <h4>{{ isPreview ? 'Daftar' : 'Pilih' }} Fasilitator</h4>
          <v-alert class="my-2" color="blue" text v-if="!isPreview">
            <v-row>
              <v-col class="grow">
                <div class="black--text">
                  Silakan pilih <b>(minimal 1, maksimal 10)</b> Fasilitator yang ingin dijadikan Anggota Kelompok
                </div>
              </v-col>
              <v-col class="shrink">
                <v-btn class="success" depressed @click="onPilihPa">
                  <v-icon left>mdi-account</v-icon>
                  Pilih Fasilitator
                </v-btn>
              </v-col>
            </v-row>
          </v-alert>
        </div>
        <template v-if="pa && pa.length">
          <div>
            <span class="blue--text">{{ pa.length }}</span> Fasilitator Terpilih
          </div>
          <v-spacer />
          <v-row v-for="(item, i) in pa" :key="item.id">
            <v-col cols="12" md="6" sm="12">
              <v-list-item class="px-0">
                <v-list-item-avatar color="blue">
                  <v-icon dark>mdi-account-circle</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="py-0 px-1">
                  <div class="blue--text">
                    {{ $getDeepObj(item, 'nama') || $getDeepObj(item, 'ptk.data.nama') || '-' }}
                  </div>
                  <div class="black--text">
                    No.UKG/SIMPKBID :
                    {{
                      $getDeepObj(item, 'ptk.data.no_ukg') ||
                        $getDeepObj(item, 'ptk.data.ptk_id') ||
                        $getDeepObj(item, 'ptk.data.ptk_id') ||
                        '-'
                    }}
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" md="3" sm="12">
              <v-list-item class="px-0">
                <v-list-item-content class="py-0">
                  <v-list-item-title>
                    <v-label color="caption"><small>Email </small></v-label>
                  </v-list-item-title>
                  <div class="link black--text body-2">
                    {{ $getDeepObj(item, 'email') || $getDeepObj(item, 'ptk.data.email') || '-' }}
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" md="1" sm="1" v-if="!isPreview">
              <div class="mt-2" />
              <v-btn icon color="red" @click="onDelete(i)"><v-icon>mdi-close-circle</v-icon></v-btn>
            </v-col>
          </v-row>
        </template>
      </v-container>
    </v-card>
    <base-list-popup
      ref="popup"
      :api="`koordinator/getKandidat`"
      :useDetail="true"
      title="Pilih Fasilitator"
      lblBtnSave="Pilih"
      multiselect
    />
  </div>
</template>
<script>
import BaseListPopup from '@components/base/BaseListPopup';
export default {
  props: {
    initValue: {
      type: Object,
      default: () => null,
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    tahun_ke: {
      default: 1,
    },
  },
  components: { BaseListPopup },
  data() {
    return {
      form: {},
      pa: [],
      initPa: [],
      koordinator: {},
    };
  },
  methods: {
    initForm(value) {
      if (!value) return;
      this.koordinator = value || {};
      this.initPa = (this.$getDeepObj(value, `psp_kp_pa_koordinators.data`) || []).map(
        (item) => item.psp_profil_pa.data
      );
      this.pa = [].concat(this.initPa);
    },

    reset() {
      this.$set(this, 'form', {});
      this.$set(this, 'initPa', []);
    },

    getValue() {
      let form = this.form;
      let pa = [];
      this.pa.forEach((item) => {
        pa.push({
          koordinator_id: this.koordinator.id,
          akun_instansi_id: this.koordinator.akun_instansi_id,
          psp_profil_id_pa: item.id,
        });
      });

      form['tahun_ke'] = this.tahun_ke;
      form['koordinators'] = pa;
      return {
        form: form,
        id: this.koordinator.id,
      };
    },

    onPilihPa() {
      const fields = [
        {
          key: 'ptk.data.nama',
          title: 'Nama',
          icon: 'mdi-account-circle',
          grid: { md: 4, sm: 12, cols: 12 },
        },
        {
          key: 'ptk.data.id',
          title: 'No. UKG/SIMPKBID',
          grid: { md: 3, sm: 12, cols: 12 },
        },
        {
          key: 'ptk.data.email',
          title: 'Alamat Surel',
          grid: { md: 4, sm: 12, cols: 12 },
        },
      ];

      const params = { tahun_ke: this.tahun_ke };
      const oldPa = [...new Set([...this.pa])].map((item) => Number(item.id));
      this.$refs.popup.open(fields, params, oldPa).then((data) => {
        if (data) {
          this.pa = [...new Set([...this.pa, ...(Object.values(data) || [])])];
        }
      });
    },

    validate() {
      let status = true;
      const pa = (this.pa && Object.values(this.pa || {})) || [];
      if (pa.length < 1 || pa.length > 10) {
        this.$error('Fasilitator hanya bisa dipilih minimal 1 dan maksimal 10');
        status = false;
      }
      return status;
    },

    onDelete(index) {
      this.pa.splice(index, 1);
    },
  },

  watch: {
    initValue: 'initForm',
  },
};
</script>
